import type { InfiltrationStage, KeyboardLikeEvent } from "../InfiltrationStage";

export class VictoryModel implements InfiltrationStage {
  onKey(__: KeyboardLikeEvent) {}
}
